export default __webpack_public_path__ + "static/media/icon-02.e87074ee.svg";